'use client';

import React, { useState } from 'react';
import { InternalProvider } from '../../util';
import { Icon } from '../Icon';
import { CalloutActions } from './CalloutActions';
import { CalloutContentComponent, CalloutElement, CalloutHeading, MediaWrapper, TopContainer } from './elements';
const DEFAULT_LINE_LIMIT = 2;
export const Callout = /*#__PURE__*/React.forwardRef(({
  id,
  className,
  ariaLabel = '',
  heading,
  content,
  primaryButton,
  secondaryButton,
  primaryAction,
  secondaryAction,
  linkOne,
  compressConfig,
  iconSrc,
  media
}, ref) => {
  // Whether to use the Read more/less feature
  const compressionEnabled = !!(compressConfig !== null && compressConfig !== void 0 && compressConfig.compressableContent);
  const [isCompressed, setIsCompressed] = useState(compressionEnabled && compressConfig.startCompressed !== false);
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(CalloutElement, {
    "data-aui": "callout",
    id: id,
    "aria-label": ariaLabel,
    className: className,
    ref: ref
  }, /*#__PURE__*/React.createElement(TopContainer, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CalloutHeading, null, heading), /*#__PURE__*/React.createElement(CalloutContentComponent, {
    compressionEnabled: compressionEnabled,
    isCompressed: isCompressed,
    compressLineLimit: (compressConfig === null || compressConfig === void 0 ? void 0 : compressConfig.compressLineLimit) || DEFAULT_LINE_LIMIT,
    content: content
  })), (iconSrc || media) && /*#__PURE__*/React.createElement(MediaWrapper, {
    hasIcon: iconSrc && true
  }, iconSrc && /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc,
    size: "xxxlarge",
    fill: "currentColor"
  }), media)), /*#__PURE__*/React.createElement(CalloutActions, {
    primaryButton,
    secondaryButton,
    primaryAction,
    secondaryAction,
    linkOne,
    compressionEnabled,
    isCompressed,
    setIsCompressed
  })));
});